import { useHistory, useLocation } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import styled from 'foundations-theming/utils';
import { LikeLink } from '../AcademyLinks';
import { removeTrailingSlash } from '../../utils/RoutingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const AwardLink = styled(LikeLink).withConfig({
  displayName: "TrackViewAwardLink__AwardLink",
  componentId: "tabel7-0"
})(["color:", ";text-decoration:underline;:hover{color:", ";}"], ({
  theme,
  use
}) => use === 'on-light' ? theme.color['text-interactive-default'] : theme.color['text-interactive-on-fill'], ({
  theme,
  use
}) => use === 'on-light' ? theme.color['text-interactive-default-hover'] : theme.color['text-interactive-on-fill-hover']);
const TrackViewAwardLink = ({
  award,
  certification,
  trackId,
  useCurrentText,
  useButton = true,
  use = useButton ? 'primary' : 'dark',
  expired,
  likeLink
}) => {
  const history = useHistory();
  const {
    pathname,
    search
  } = useLocation();
  if (!award) {
    return null;
  }
  const noTrailingUrl = removeTrailingSlash(pathname);
  const link = `${noTrailingUrl}/award/${trackId}${search}`;
  let label = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.common.viewCertificateOfCompletion"
  });
  if (certification) {
    label = useCurrentText ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.common.viewCurrentCertification"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.common.viewCertification"
    });
  }
  if (expired) {
    label = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.common.viewExpiredCertification"
    });
  }
  if (likeLink) {
    return (
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsx(AwardLink, {
        onClick: e => {
          e.preventDefault();
          history.push(link);
        },
        use: use,
        children: label
      })
    );
  }
  if (useButton) {
    return /*#__PURE__*/_jsx(RouterButton, {
      "data-test-id": "view-award-button",
      to: link,
      use: use,
      children: label
    });
  }
  return /*#__PURE__*/_jsx(RouterLink, {
    "data-test-id": "view-award-button",
    to: link,
    use: use,
    children: label
  });
};
export default TrackViewAwardLink;